"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/tabindex-no-positive */
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("~/consts/routes");
const accountTabs_1 = require("~/consts/accountTabs");
const useClickOutsideHandler_1 = __importDefault(require("~/hooks/useClickOutsideHandler"));
const consts_1 = require("~/store/account/consts");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const assets_1 = require("~/assets");
const consts_2 = require("~/store/consts");
const AccountDropdown_module_scss_1 = __importDefault(require("./AccountDropdown.module.scss"));
function AccountDropdown() {
    const { t } = (0, react_i18next_1.useTranslation)('account');
    const showDropdown = (0, react_redux_1.useSelector)(selectors_1.selectShowDropdown);
    const currentTabId = (0, react_redux_1.useSelector)(selectors_1.selectCurrentTabId);
    const isUserLogged = (0, react_redux_1.useSelector)(selectors_1.selectIsUserLogged);
    const userType = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserRole);
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const currentProject = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProject);
    const referenceNumber = currentProject === null || currentProject === void 0 ? void 0 : currentProject.referenceNumber;
    const isNeedHelpEnabled = (0, react_redux_1.useSelector)(selectors_1.selectIsNeedHelpEnabled);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [logOut, setLogOut] = (0, react_1.useState)(false);
    const wrapperRef = (0, react_1.useRef)(null);
    const elementRef = (0, react_1.useRef)(null);
    const { dispatchToggleAccountDropDown, dispatchToggleWidget, dispatchEditMode } = (0, redux_1.bindActionCreators)({
        dispatchToggleAccountDropDown: actions_1.toggleAccountDropDown,
        dispatchToggleWidget: actions_1.toggleWidget,
        dispatchEditMode: actions_1.editMode,
    }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        if (logOut) {
            dispatchEditMode(false);
            dispatchToggleWidget({
                widgetName: consts_2.WIDGETS.RECOMMENDED_FASTENERS_WIDGET,
                show: false,
            });
            // NavigateFunction can not be used inside of render function. It has to be wrapped within an useEffect or called in an event handler.
            navigate(routes_1.ROUTE_SIGNOUT, { replace: true });
            setLogOut(false);
        }
    }, [logOut]);
    const handleLogOut = () => {
        setLogOut(true);
    };
    const hideDropdown = () => dispatchToggleAccountDropDown(false);
    const navigateToAdmin = () => {
        var _a;
        const SITE_PORT = process.env.SITE_PORT;
        const SITE_HOSTNAME = (_a = process.env.SITE_HOSTNAME) === null || _a === void 0 ? void 0 : _a.replace(/:[0-9]+/i, '');
        const adminRoute = `${SITE_HOSTNAME}:${SITE_PORT}/admin`;
        window.location.href = adminRoute;
    };
    const openHelpEmail = () => {
        const subjectText = referenceNumber
            ? `Help request \u2013 ${referenceNumber}`
            : 'Help request';
        const subject = encodeURIComponent(subjectText);
        hideDropdown();
        window.location.href = `mailto:${accountTabs_1.HELP_SUPPORT_EMAIL}?subject=${subject}`;
    };
    (0, useClickOutsideHandler_1.default)(wrapperRef, elementRef, hideDropdown);
    (0, react_1.useEffect)(() => {
        if (!isUserLogged) {
            hideDropdown();
        }
    }, [isUserLogged]);
    const getUserTabs = () => {
        if (userType === consts_1.UserRoles.distributor) {
            if (user && user.distributor && user.distributor.isDirectAccount) {
                return accountTabs_1.isDirectAccountUserTabs;
            }
            return accountTabs_1.distributorUserTabs;
        }
        return accountTabs_1.customerUserTabs;
    };
    const adminTab = {
        id: 5,
        icon: assets_1.svgAdmin,
        title: t('dropdown-menu.admin'),
        handlerType: 'admin',
        route: '',
    };
    return showDropdown ? (react_1.default.createElement("div", { className: AccountDropdown_module_scss_1.default.container, ref: wrapperRef },
        react_1.default.createElement("div", { className: AccountDropdown_module_scss_1.default.top }, [...accountTabs_1.accountTabs, ...getUserTabs()]
            .sort((first, second) => 0 - (first.id > second.id ? -1 : 1))
            .map((tab) => {
            const isSelected = String(tab.id === currentTabId);
            let handler = {};
            switch (tab.handlerType) {
                case 'default':
                    handler = { onClick: hideDropdown };
                    break;
                case 'logout':
                    handler = { onClick: handleLogOut };
                    break;
                case 'admin':
                    if (userType !== consts_1.UserRoles.admin) {
                        return null;
                    }
                    handler = { onClick: navigateToAdmin };
                    break;
                default:
                    break;
            }
            return (react_1.default.createElement(react_router_dom_1.Link, Object.assign({ to: tab.route }, handler, { "data-active-tab": isSelected, key: tab.id, ref: elementRef }),
                react_1.default.createElement("div", { className: AccountDropdown_module_scss_1.default.button, role: "button", tabIndex: 0 },
                    react_1.default.createElement("img", { src: tab.icon, alt: "" }),
                    t(tab.title))));
        })),
        userType === consts_1.UserRoles.admin && (react_1.default.createElement("div", { className: AccountDropdown_module_scss_1.default.bottom },
            react_1.default.createElement("button", { className: AccountDropdown_module_scss_1.default['go-to-admin-btn'], onClick: navigateToAdmin, "data-active-tab": currentTabId === adminTab.id, key: adminTab.id, ref: elementRef, type: "button" },
                react_1.default.createElement("div", { className: AccountDropdown_module_scss_1.default.button, role: "button", tabIndex: 0 },
                    react_1.default.createElement("img", { src: adminTab.icon, alt: "admin" }),
                    adminTab.title)),
            react_1.default.createElement("div", { className: AccountDropdown_module_scss_1.default.version },
                react_1.default.createElement("span", { className: AccountDropdown_module_scss_1.default['version-label'] }, "Ver:"),
                " ",
                process.env.GIT_COMMIT_HASH))),
        userType !== consts_1.UserRoles.admin && isNeedHelpEnabled && (react_1.default.createElement("div", { className: AccountDropdown_module_scss_1.default['need-help'] },
            react_1.default.createElement("button", { className: AccountDropdown_module_scss_1.default['need-help-btn'], onClick: openHelpEmail, type: "button" },
                react_1.default.createElement("div", { className: AccountDropdown_module_scss_1.default.button, role: "button", tabIndex: 0 },
                    react_1.default.createElement("img", { src: assets_1.svgHelpEmail, alt: "" }),
                    t('dropdown-menu.need-help'))))))) : null;
}
exports.default = AccountDropdown;
